<template>
  <span v-if="value" class="tw-text-alert">
    <template v-for="error in value">
      {{error}}<br/>
    </template>
  </span>
</template>
<script>
export default {
  props: ['value'],
}
</script>